import GradeLabel from './GradeLabel';

export default GradeLabel;
